<template>
  <div>
    <div class="clearfix"></div>
    <div class="banner">
      <white-menu ref="whiteMenu"></white-menu>
    </div>
    <div @click="handleCloseMenu">
      <h1 class="f_spec_sc-R text-center user-title">My Account</h1>
      <div class="user-bar">
        <div class="container">
          <ul class="row">
          <li class="col-xs-2 account-item">
            <a href="javascript:;" @click="handleChangeView('user-dashboard')" :class="[currentView == 'user-dashboard' ? 'active' : '']">
              <i class="icons user-icon1"></i>
              <span>Dashboard</span>
            </a>
          </li>
          <li class="col-xs-2 account-item">
            <a href="javascript:;" @click="handleChangeView('user-profile')" :class="{ 'active': isProfileActive }">
              <i class="icons user-icon2"></i>
              <span>Profile</span>
            </a>
          </li>
          <li class="col-xs-2 account-item">
            <a href="javascript:;" @click="handleChangeView('user-myPurchase')" :class="[currentView == 'user-myPurchase' ? 'active' : '']">
            <i class="icons user-icon3"></i>
            <span>My Purchase</span></a>
          </li>
          <li class="col-xs-2 account-item">
            <a href="javascript:;" @click="handleMessage()"><i class="icons user-icon4"></i>
            <span>My Sale</span>
            <p>* Comming Soon *</p></a>
          </li>
          <li class="col-xs-2 account-item">
            <a href="javascript:;" @click="handleChangeView('user-MyWishlist')" :class="[currentView == 'user-MyWishlist' ? 'active' : '']"><i class="icons user-icon5"></i>
            <span>My Wishlist</span></a>
          </li>
          <li class="col-xs-2 account-item">
            <a href="javascript:;" @click="handleMessage()"><i class="icons user-icon6"></i>
            <span>Services</span></a>
          </li>
          </ul>
        </div>
      </div>

      <component ref="currentView" :is="currentView" v-on:change-user="handleEdit"></component>
    </div>
  </div>
</template>

<script>
import WhiteMenu from "@/components/WhiteMenu";
import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';

export default {
  name: 'UserView',
  components: {
  	WhiteMenu,
    'user-dashboard': () => import('@/components/UserDashboard'),
    'user-profile': () => import('@/components/UserProfile'),
    'user-myPurchase': () => import('@/components/UserMyPurchase'),
    'user-MyWishlist': () => import('@/components/UserMyWishlist'),
    'user-change-email': () => import('@/components/UserChangeEmail'),
    'user-change-password': () => import('@/components/UserChangePassword'),
    'user-reset-password': () => import('@/components/UserResetPassword'),
  },
  data() {
    return {
      currentView: 'user-dashboard',
      isProfileActive: false,
      resetPassword: undefined,
    }
  },
  created() {
    console.log(this.$route.query)
    if (this.$route.query && this.$route.query.resetPassword) {
      this.isProfileActive = true;
      this.currentView = 'user-reset-password';
    } else if(!this.$store.getters.userId){
       this.$router.push('/login')
       return
    }
    console.log(this.$route.query.current)
    if(this.$route.query.current){
      this.currentView = this.$route.query.current
    }
  },
  mounted() {
  },
  methods: {
    handleCloseMenu(event) {
      var sp = document.getElementById("headMenu")
      if (!sp.contains(event.target)) {
      	this.$refs.whiteMenu.searchFocus = false;
      	this.$refs.whiteMenu.isHovered = false;
      }
    },
    handleChangeView(curView) {
      console.log('进来了')
      console.log(curView)
      this.currentView = curView;
      if (curView == 'user-profile' || curView == 'user-change-email' ||
          curView == 'user-change-password' || curView == 'user-reset-password') {
              this.isProfileActive = true;
      } else {
        this.isProfileActive = false;
        if (this.$route.query && Object.keys(this.$route.query).length > 0) {
          this.$router.push({ query: {}})
        }
      }
    },
    handleMessage(){
      alert('暂未开放')
    },
    handleEdit(val) {
      console.log(val)
      this.currentView = val;
      this.isProfileActive = true;
      this.$refs.currentView.$el.scrollIntoView({behavior: "smooth"})
    }

  }
}
</script>

<style scoped>
  @import url("../assets/xh/css/bootstrap.min.css");
  @import url("../assets/xh/css/reset.css");
  @import url('../assets/xh/css/user.css');

</style>



// WEBPACK FOOTER //
// src/views/UserView.vue